/**
 * **************************************************************************
 * Admin - external links service file
 *
 * Defines all http api calls required in tools page
 * Calls server apis and returns data to components
 * **************************************************************************
 */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { externalLink } from '@app/model/externalLink.model';
import { ApiService } from '@app/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ExtLinksService {

    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    links: any;
    linksWithIcons: any[] = [];
    loader  = new HttpHeaders({ isLoader: "true" });
    /**
     * Event Name : linksEvent
     * emited from:
     *      - navbar component
     *      - external-links component
     * subscribed:
     *      - cicdDashboard component 
     */
    linksEvent : EventEmitter<any> = new EventEmitter(); 

    /**
     * Constructor
     * @param httpClient
     * @param apiService
     */
    constructor(
        private httpClient: HttpClient,
        private apiService: ApiService
    ) { }

    /**
     * External links APIs
     */
    public extLinksApis = this.apiService.EXT_LINKS;
    public extLinksUrl = this.apiService.KPID_URL + this.extLinksApis.EXT_LINKS;

    /**
     * Image upload and get APIs
     */
    public extLinksImgApis = this.apiService.IMAGE;
    public extLinksImgUrl = this.apiService.KPID_URL + this.extLinksImgApis.IMAGE;

    /******** External links APIs ********/

    /**API call for adding new link */
    addExternalLinks(newLink: externalLink) {
        return this.httpClient.post<any>(this.extLinksUrl + this.extLinksApis.ADD_EXT_LINKS, newLink, { headers: this.headers });
    }

    /**API call for fetching all data */
    getExternalLinksData(): Observable<any> {
        return this.httpClient.get(this.extLinksUrl + this.extLinksApis.GET);
    }

    /**API call for sending updated data to save in the backend */
    updateExternalLinksData(diffObj: any, id: Number) {
        return this.httpClient.patch<any>(this.extLinksUrl + this.extLinksApis.UPDATE_EXT_LINKS(id), diffObj, { headers: this.headers });
    }

    /**API call for deleting the link using ID */
    deleteExternalLinksData(id: any) {
        return this.httpClient.patch<any>(this.extLinksUrl + this.extLinksApis.UPDATE_EXT_LINKS(id), { delete: true });
    }

    /**API call for check the link using LABEL */
    checkActive(label: string | undefined) {
        return this.httpClient.get<any>(this.extLinksUrl + this.extLinksApis.CHECK_ACTIVE(label));
    }

    /******** Image APIs ********/

    /** Get image based on id */
    getImage(id: number) {
        let options: any = { headers: this.loader }
        return this.httpClient.get(this.extLinksImgUrl + this.extLinksImgApis.GET(id), options);
    }

    uploadImage(fileName: string, url: any, id?: number) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
        return this.httpClient.post(this.extLinksImgUrl + this.extLinksImgApis.UPLOAD(fileName, id), url, { headers });
    }

    deleteImage(id: number) {
        return this.httpClient.delete(this.extLinksImgUrl + this.extLinksImgApis.DELETE(id));
    }
}
